import { render, staticRenderFns } from "./EntradaTrasladoComponent.vue?vue&type=template&id=77be4ce6&"
import script from "./EntradaTrasladoComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaTrasladoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports